import React from 'react';
import cn from 'classnames';

import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './DropArea.scss';

type Props = {
  className?: string;
  isTop?: boolean;
  isBottom?: boolean;
  isDropAsChild?: boolean;
};

export function DropArea({ className = '', isDropAsChild = false, isTop = false, isBottom = false }: Props) {
  const { tr } = useTranslation();

  return (
    <div
      className={cn(`drop-area d-flex ${className}`, {
        'drop-area--is-top': isTop,
        'drop-area--is-bottom': isBottom,
        'drop-area--is-drop-as-child': isDropAsChild,
      })}
    >
      <div className="drop-area-content m-auto">{tr('perform.drag_drop.drop_area.drop_here')}</div>
    </div>
  );
}
